'use strict';

import React, { Component } from 'react'

import { v4 as uniqid } from 'uuid'
import _      from 'lodash'

import Layout from '@Layout/BackOffice'

import FormElement from '@/Form/toolkit/FormElement'
import FileInput   from '@/Form/toolkit/FileInput'

import { handleChange } from '@/Form/Functions/eventsHandling'
import getFormStatus    from '@/Form/Functions/getFormStatus'
import getFormData      from '@/Form/Functions/getFormData'

import Loader from '@Pure/Loader'

import ajaxRequest from '@function/ajax/ajaxRequest'

const { app } = window;

const header_info = 'Format des colonnes: Désignation, Adresse, Complément d\'adresse, Code postal, Ville';

export default class NewNationalBrandPage extends Component
{
	state = { form_data: { }, status_messages: { }, file_id: uniqid() };

	UNSAFE_componentWillMount ()
	{
		app.resetFunctions();
	}

	handleChange = handleChange.bind(this);

	handleSubmit = async (e) =>
	{
		const component = this, props = this.props, state = this.state;

		e.preventDefault();

		if (state.loading) return;

		component.setState({ loading: true, errors: [], error: undefined });

		const form_data = getFormData({ state: state.form_data, pattern: 'brand[' });

		try
		{
			await ajaxRequest('/import/national-brand',
			{
				data: form_data,
				axios_params:
				{
					timeout: 60 * 1000 * 5 // 5mn
				},
				files: true
			});
		}
		catch (e)
		{
			console.error(e);
			console.log('errors', e.errors);

			return component.setState({ ...e, file_id: uniqid() });
		}

		component.setState(
		{
			loading: false,

			info: 'Import réussi.',
			error: undefined,
			warning: undefined,

			form_data: { 'brand[name]': '', 'brand[import_files]': [] },

			'__files-brand[import_files]': [],

			file_id: uniqid()
		});
	}

	handleFileChange = (e, data={ }) =>
	{
		const component = this, props = this.props, state = this.state;

		let { name, value:previews=[] } = data;

		const update = { ...state.form_data };

		const binaries_name = '__files-' + name;

		if (previews[0])
		{
			update[binaries_name].push({ ...previews[0] });
		}
		else
		{
			update[binaries_name] = [];
		}

		if (previews[0])
		{
			let infos = _.cloneDeep(previews[0]);

			delete infos.file;
			delete infos.pdf;
			delete infos.image;

			update[name].push(infos);
		}
		else
		{
			update[name] = [];
		}

		component.setState(
		{
			form_data: update,

			...(previews[0] ? { errors: [] } : { })
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const loader = state.loading === true ?
		(
			<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
		)
		: undefined;

		var output =
		(
			<Layout page_title="Nouvelle enseigne nationale" history={ props.history }>

				<div className="page-content">

					<div className="o-content">

						<div className="page-form-container">

							<form action="/import/national-brand"
								className="c-form c-form--creation" method="POST"
								onSubmit={ component.handleSubmit }>

								<div className="c-title c-title--form">
									<h2 className="c-title__txt">
										Nouvelle enseigne nationale
									</h2>
								</div>

								<FormElement className="u-margin-top-0 u-margin-bottom-20"
									type="text" name="brand[name]"
									data={ state.form_data }
									placeholder="Pour la retrouver plus facilement"
									label="Nom de l'enseigne"
									status={ state.status_messages }
									onChange={ component.handleChange }
								/>

								<FileInput id_prefix="national-brand-import-"
									label="Fichier .csv ou .txt des adresses"
									name="brand[import_files]"
									onChange={ component.handleFileChange }
									data={ state.form_data }
									multiple={ false }
									status={ state.status_messages }
									accept=".csv, .txt"
									key={ state.file_id }
								/>

								{
									getFormStatus(
										{ statement: header_info },
										{ style: { marginBottom: 5 } }
									)
								}

								{
									state.errors?.length ?
									(
										state.errors
										.map(error => getFormStatus({ error }, { style: { marginTop: 5, marginBottom: 5 } }))
									)
									: getFormStatus(state)
								}
								<button type="submit" className="c-btn c-btn--secondary c-btn--next u-margin-top-15">
									Créer et importer
									{ loader }
								</button>

							</form>

						</div>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}
